import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableMultipackagePhase2 = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableMultipackagePhase2);
};
